import React from "react";

export function UsdtIcon(props) {
  return (
    <svg {...props} viewBox="0 0 24 24" aria-hidden="true">
      <title>usdt</title>
      <path fill="#009393" d="m12 19.2l-9-8.88L6.433 4.8h11.134L21 10.32zm.9-8.1v-1.098c1.62.08 3.132.396 3.6.805c-.544.477-2.493.824-4.5.824s-3.956-.347-4.5-.824c.463-.41 1.98-.72 3.6-.81V11.1zm-5.4-.297v.661c.463.41 1.975.72 3.6.81V14.7h1.8v-2.43c1.62-.081 3.136-.396 3.6-.806v-1.318c-.464-.41-1.98-.725-3.6-.81V8.4h2.7V7.05H8.4V8.4h2.7v.936c-1.625.085-3.137.4-3.6.81z"/>
    </svg>
  );
}

export function UsdcIcon(props) {
  return (
    <svg {...props} viewBox="0 0 32 32" aria-hidden="true">
      <title>usdc</title>
      <g fill="none">
        <circle cx="16" cy="16" r="16" fill="#3E73C4"/>
        <g fill="#FFF">
          <path d="M20.022 18.124c0-2.124-1.28-2.852-3.84-3.156c-1.828-.243-2.193-.728-2.193-1.578s.61-1.396 1.828-1.396c1.097 0 1.707.364 2.011 1.275a.46.46 0 0 0 .427.303h.975a.416.416 0 0 0 .427-.425v-.06a3.04 3.04 0 0 0-2.743-2.489V9.142c0-.243-.183-.425-.487-.486h-.915c-.243 0-.426.182-.487.486v1.396c-1.829.242-2.986 1.456-2.986 2.974c0 2.002 1.218 2.791 3.778 3.095c1.707.303 2.255.668 2.255 1.639c0 .97-.853 1.638-2.011 1.638c-1.585 0-2.133-.667-2.316-1.578c-.06-.242-.244-.364-.427-.364h-1.036a.416.416 0 0 0-.426.425v.06c.243 1.518 1.219 2.61 3.23 2.914v1.457c0 .242.183.425.487.485h.915c.243 0 .426-.182.487-.485V21.34c1.829-.303 3.047-1.578 3.047-3.217z"/>
          <path d="M12.892 24.497c-4.754-1.7-7.192-6.98-5.424-11.653c.914-2.55 2.925-4.491 5.424-5.402c.244-.121.365-.303.365-.607v-.85c0-.242-.121-.424-.365-.485c-.061 0-.183 0-.244.06a10.895 10.895 0 0 0-7.13 13.717c1.096 3.4 3.717 6.01 7.13 7.102c.244.121.488 0 .548-.243c.061-.06.061-.122.061-.243v-.85c0-.182-.182-.424-.365-.546m6.46-18.936c-.244-.122-.488 0-.548.242c-.061.061-.061.122-.061.243v.85c0 .243.182.485.365.607c4.754 1.7 7.192 6.98 5.424 11.653c-.914 2.55-2.925 4.491-5.424 5.402c-.244.121-.365.303-.365.607v.85c0 .242.121.424.365.485c.061 0 .183 0 .244-.06a10.895 10.895 0 0 0 7.13-13.717c-1.096-3.46-3.778-6.07-7.13-7.162"/>
        </g>
      </g>
    </svg>
  );
}

export function DaiIcon(props) {
  return (
    <svg {...props} viewBox="0 0 32 32" aria-hidden="true">
      <title>dai</title>
      <g fill="none" fillRule="evenodd">
        <circle cx="16" cy="16" r="16" fill="#F4B731" fillRule="nonzero"/>
        <path fill="#FFF" d="M9.277 8h6.552c3.985 0 7.006 2.116 8.13 5.194H26v1.861h-1.611q.047.441.047.898v.046q0 .514-.06 1.01H26v1.86h-2.08C22.767 21.905 19.77 24 15.83 24H9.277v-5.131H7v-1.86h2.277v-1.954H7v-1.86h2.277zm1.831 10.869v3.462h4.72c2.914 0 5.078-1.387 6.085-3.462zm11.366-1.86H11.108v-1.954h11.37q.062.46.063.944v.045q0 .493-.067.964zM15.83 9.665c2.926 0 5.097 1.424 6.098 3.528h-10.82V9.666h4.72z"/>
      </g>
    </svg>
  );
}

export function EthIcon(props) {
  return (
    <svg {...props} viewBox="0 0 32 32" aria-hidden="true">
      <title>eth</title>
      <g fill="none" fillRule="evenodd">
        <circle cx="16" cy="16" r="16" fill="#627EEA"/>
        <g fill="#FFF" fillRule="nonzero">
          <path fillOpacity=".602" d="M16.498 4v8.87l7.497 3.35z"/>
          <path d="M16.498 4L9 16.22l7.498-3.35z"/>
          <path fillOpacity=".602" d="M16.498 21.968v6.027L24 17.616z"/>
          <path d="M16.498 27.995v-6.028L9 17.616z"/>
          <path fillOpacity=".2" d="m16.498 20.573l7.497-4.353l-7.497-3.348z"/>
          <path fillOpacity=".602" d="m9 16.22l7.498 4.353v-7.701z"/>
        </g>
      </g>
    </svg>
  );
}

export function ShibIcon(props) {
  return (
    <svg {...props} viewBox="0 0 24 24" aria-hidden="true">
      <title>shib</title>
      <g fill="none">
        <path fill="#eb9a2e" d="M4.246 14.796c0-1.654.819-3.62 1.228-4.397c-.625-1.964-1.64-6.074-.703-6.8c.938-.726 3.2 1.687 4.214 2.984c.415-.219 1.589-.656 2.974-.656s2.686.437 3.165.656c2.727-3.052 3.868-3.26 4.097-2.984c.964 1.218-.04 5.04-.664 6.8c.403.644 1.205 2.426 1.205 4.398c0 2.463-3.54 5.995-7.818 5.995c-4.279 0-7.698-3.928-7.698-5.996"/>
        <path fill="#e58014" fillRule="evenodd" d="M5.72 9.372c-.367-1.237-.988-3.881-.55-4.564c.44-.683 2.199 1.027 3.023 1.967c-.475.38-1.635 1.43-2.474 2.597m12.651 0c.366-1.237.988-3.881.549-4.564c-.44-.683-2.198 1.027-3.023 1.967c.475.38 1.636 1.43 2.474 2.597" clipRule="evenodd"/>
        <path fill="#fefff7" d="M9.19 11.081q-.617.112-1.242.08a.314.314 0 0 1-.305-.285c-.04-.506.152-1.182.726-1.155c.689.032.99.542 1.095.961c.047.189-.085.365-.274.4m5.65 0c.49.09.942.097 1.243.08a.315.315 0 0 0 .305-.285c.039-.506-.153-1.182-.727-1.155c-.688.032-.989.542-1.094.961c-.047.189.084.365.273.4"/>
        <path fill="#eaeae8" d="M11.526 20.69c-5.887-.897-7.305-4.31-7.279-5.904c3.042-.225 4.085.952 4.226 1.568c.081-.938.873-2.817 3.389-2.817s3.307 1.878 3.388 2.817a4.17 4.17 0 0 1 4.614-1.368c-1.44 4.787-6.159 5.798-8.338 5.704"/>
        <path fill="#000001" fillRule="evenodd" d="M12.778 14.442h-1.633a.413.413 0 0 0-.41.416v.806c.024.26.265.76 1.023.844v.8a.5.5 0 0 0-.115.168h-.977v.01a1.8 1.8 0 0 0-.339-.247a.103.103 0 0 0-.147.12a.1.1 0 0 0 .05.063c.065.036.166.1.252.175a1 1 0 0 1 .108.112q.04.056.044.084q.006.032.026.054v.447c0 .057.046.104.102.104a.103.103 0 0 0 .102-.104v-.611h2.196v.61c0 .058.046.105.102.105a.1.1 0 0 0 .073-.031a.1.1 0 0 0 .03-.073v-.5l.003-.018l.002-.004a.2.2 0 0 1 .025-.035a1 1 0 0 1 .114-.105a3 3 0 0 1 .286-.198a.105.105 0 0 0-.026-.19a.1.1 0 0 0-.078.01a3 3 0 0 0-.31.215l-.008.006h-1.025a.4.4 0 0 0-.08-.105v-.858c.786-.07 1.009-.583 1.02-.848v-.806a.413.413 0 0 0-.41-.416m-1.501 3.54l.216.265l.166-.157l.3.29l.31-.29l.145.157l.2-.266z" clipRule="evenodd"/>
        <path fill="#000" d="M7.507 11.766c-.302-.118-.305.16-.269.312v.232a1.04 1.04 0 0 0 .664.969c.913.343 2.456.818 2.287.32c-.223-.655-2.306-1.684-2.682-1.833m8.935 0c.3-.118.304.16.268.312v.232a1.04 1.04 0 0 1-.664.969c-.913.343-2.456.818-2.287.32c.223-.655 2.306-1.684 2.683-1.833"/>
        <path fill="#000" fillRule="evenodd" d="M8.981 6.106C8.095 5.009 6.998 3.78 5.643 3.242c-3.164-1.257-.922 5.982-.59 7.026c-.435.842-1.256 2.814-1.256 4.48c0 3.606 5.209 6.252 8.208 6.252c3.132 0 8.198-2.56 8.198-6.252c0-1.955-.743-3.679-1.18-4.414c.673-1.916 1.915-5.405.573-7.126c-.904-1.082-4.11 2.395-4.5 2.823c-.585-.24-1.808-.526-3.138-.526c-1.306 0-2.441.357-2.977.6M4.764 3.624c-.075.057-.144.16-.199.324a2.5 2.5 0 0 0-.1.623c-.027.5.03 1.132.14 1.814c.215 1.36.63 2.88.945 3.864l.028.085l-.042.078c-.411.774-1.225 2.72-1.225 4.336c0 .468.197 1.068.582 1.716c.383.644.94 1.318 1.632 1.931c1.387 1.226 3.363 2.046 5.48 2.046c2.123 0 4.007-.725 5.422-1.9c1.424-1.183 2.272-2.641 2.272-3.793c0-1.938-.801-3.697-1.195-4.323l-.054-.086l.034-.096c.314-.879.724-2.273.934-3.595c.105-.661.159-1.297.128-1.838c-.032-.543-.146-.96-.348-1.216c-.006-.004-.046-.03-.174-.01c-.149.022-.377.104-.699.299c-.642.387-1.61 1.192-2.994 2.724l-.1.11l-.135-.06c-.466-.212-1.764-.644-3.138-.644c-1.054 0-2.144.225-3.082.717c-.675-.855-1.407-1.677-2.249-2.371c-.37-.306-1.33-1.144-1.863-.735" clipRule="evenodd"/>
      </g>
    </svg>
  );
}

export function BtcIcon(props) {
  return (
    <svg {...props} viewBox="0 0 32 32" aria-hidden="true">
      <title>btc</title>
      <g fill="none" fillRule="evenodd">
        <circle cx="16" cy="16" r="16" fill="#F7931A"/>
        <path fill="#FFF" fillRule="nonzero" d="M23.189 14.02c.314-2.096-1.283-3.223-3.465-3.975l.708-2.84l-1.728-.43l-.69 2.765c-.454-.114-.92-.22-1.385-.326l.695-2.783L15.596 6l-.708 2.839q-.565-.127-1.104-.26l.002-.009l-2.384-.595l-.46 1.846s1.283.294 1.256.312c.7.175.826.638.805 1.006l-.806 3.235q.073.017.18.057l-.183-.045l-1.13 4.532c-.086.212-.303.531-.793.41c.018.025-1.256-.313-1.256-.313l-.858 1.978l2.25.561c.418.105.828.215 1.231.318l-.715 2.872l1.727.43l.708-2.84q.707.19 1.378.357l-.706 2.828l1.728.43l.715-2.866c2.948.558 5.164.333 6.097-2.333c.752-2.146-.037-3.385-1.588-4.192c1.13-.26 1.98-1.003 2.207-2.538m-3.95 5.538c-.533 2.147-4.148.986-5.32.695l.95-3.805c1.172.293 4.929.872 4.37 3.11m.535-5.569c-.487 1.953-3.495.96-4.47.717l.86-3.45c.975.243 4.118.696 3.61 2.733"/>
      </g>
    </svg>
  );
}

export function BchIcon(props) {
  return (
    <svg {...props} viewBox="0 0 32 32" aria-hidden="true">
      <title>bch</title>
      <g fill="none" fillRule="evenodd">
        <circle cx="16" cy="16" r="16" fill="#8dc351"/>
        <path fill="#fff" fillRule="nonzero" d="M21.207 10.534c-.776-1.972-2.722-2.15-4.988-1.71l-.807-2.813l-1.712.491l.786 2.74c-.45.128-.908.27-1.363.41l-.79-2.758l-1.711.49l.805 2.813c-.368.114-.73.226-1.085.328l-.003-.01l-2.362.677l.525 1.83s1.258-.388 1.243-.358c.694-.199 1.035.139 1.2.468l.92 3.204c.047-.013.11-.029.184-.04l-.181.052l1.287 4.49c.032.227.004.612-.48.752c.027.013-1.246.356-1.246.356l.247 2.143l2.228-.64c.415-.117.825-.227 1.226-.34l.817 2.845l1.71-.49l-.807-2.815a66 66 0 0 0 1.372-.38l.802 2.803l1.713-.491l-.814-2.84c2.831-.991 4.638-2.294 4.113-5.07c-.422-2.234-1.724-2.912-3.471-2.836c.848-.79 1.213-1.858.642-3.3zm-.65 6.77c.61 2.127-3.1 2.929-4.26 3.263l-1.081-3.77c1.16-.333 4.704-1.71 5.34.508zm-2.322-5.09c.554 1.935-2.547 2.58-3.514 2.857l-.98-3.419c.966-.277 3.915-1.455 4.494.563z"/>
      </g>
    </svg>
  );
}

export function LtcIcon(props) {
  return (
    <svg {...props} viewBox="0 0 32 32" aria-hidden="true">
      <title>ltc</title>
      <g fill="none" fillRule="evenodd">
        <circle cx="16" cy="16" r="16" fill="#BFBBBB"/>
        <path fill="#FFF" d="M10.427 19.214L9 19.768l.688-2.759l1.444-.58L13.213 8h5.129l-1.519 6.196l1.41-.571l-.68 2.75l-1.427.571l-.848 3.483H23L22.127 24H9.252z"/>
      </g>
    </svg>
  );
}

export function DogeIcon(props) {
  return (
    <svg {...props} viewBox="0 0 32 32" aria-hidden="true">
      <title>doge</title>
      <g fill="none" fillRule="evenodd">
        <circle cx="16" cy="16" r="16" fill="#C3A634"/>
        <path fill="#FFF" d="M13.248 14.61h4.314v2.286h-4.314v4.818h2.721q1.615 0 2.644-.437q1.029-.436 1.615-1.21a4.4 4.4 0 0 0 .796-1.815a11.4 11.4 0 0 0 .21-2.252a11.4 11.4 0 0 0-.21-2.252a4.4 4.4 0 0 0-.796-1.815q-.587-.774-1.615-1.21q-1.029-.437-2.644-.437h-2.721v4.325zm-2.766 2.286H9v-2.285h1.482V8h6.549q1.815 0 3.142.627q1.327.628 2.168 1.715q.84 1.086 1.25 2.543T24 16a11.5 11.5 0 0 1-.41 3.115q-.408 1.456-1.25 2.543q-.84 1.087-2.167 1.715q-1.328.627-3.142.627h-6.549z"/>
      </g>
    </svg>
  );
}

export function DashIcon(props) {
  return (
    <svg {...props} viewBox="0 0 32 32" aria-hidden="true">
      <title>dash</title>
      <g fill="none">
        <circle cx="16" cy="16" r="16" fill="#008CE7"/>
        <g fill="#FFF">
          <path d="M19.086 8.004H11.81l-.602 3.367l6.562.01c3.231 0 4.19 1.173 4.159 3.12c-.014.998-.449 2.686-.633 3.23c-.497 1.46-1.521 3.122-5.359 3.117l-6.378-.004l-.602 3.371h7.257c2.559 0 3.649-.299 4.8-.83c2.554-1.178 4.075-3.701 4.686-6.994c.906-4.9-.224-8.387-6.615-8.387z"/>
          <path d="M15.807 15.798c.237-.985.312-1.38.312-1.38H8.673c-1.904 0-2.176 1.24-2.357 1.99c-.237.981-.312 1.381-.312 1.381h7.447c1.903 0 2.175-1.24 2.356-1.991"/>
        </g>
      </g>
    </svg>
  );
}

export function XmrIcon(props) {
  return (
    <svg {...props} viewBox="0 0 32 32" aria-hidden="true">
      <title>xmr</title>
      <g fill="none" fillRule="evenodd">
        <circle cx="16" cy="16" r="16" fill="#F60"/>
        <path fill="#FFF" fillRule="nonzero" d="M15.97 5.235c5.985 0 10.825 4.84 10.825 10.824a11 11 0 0 1-.558 3.432h-3.226v-9.094l-7.04 7.04l-7.04-7.04v9.094H5.704a11 11 0 0 1-.557-3.432c0-5.984 4.84-10.824 10.824-10.824zM14.358 19.02L16 20.635l1.613-1.614l3.051-3.08v5.72h4.547a10.8 10.8 0 0 1-9.24 5.192c-3.902 0-7.334-2.082-9.24-5.192h4.546v-5.72l3.08 3.08z"/>
      </g>
    </svg>
  );
}

export function TrxIcon(props) {
  return (
    <svg {...props} viewBox="0 0 32 32" aria-hidden="true">
      <title>trx</title>
      <g fill="none">
        <circle cx="16" cy="16" r="16" fill="#EF0027"/>
        <path fill="#FFF" d="M21.932 9.913L7.5 7.257l7.595 19.112l10.583-12.894zm-.232 1.17l2.208 2.099l-6.038 1.093zm-5.142 2.973l-6.364-5.278l10.402 1.914zm-.453.934l-1.038 8.58L9.472 9.487zm.96.455l6.687-1.21l-7.67 9.343z"/>
      </g>
    </svg>
  );
}

export function TonIcon(props) {
  return (
    <svg {...props} viewBox="0 0 24 24" aria-hidden="true">
      <title>ton</title>
      <path fill="#08c" d="m20.661 7.22l-7.846 12.494a1.058 1.058 0 0 1-1.794-.006L3.328 7.214A2.2 2.2 0 0 1 3 6.05a2.29 2.29 0 0 1 2.324-2.255h13.362C19.963 3.794 21 4.8 21 6.044c0 .413-.116.82-.339 1.175M5.218 6.8l5.723 8.826V5.912H5.816c-.592 0-.857.392-.598.89m7.84 8.826L18.783 6.8c.265-.497-.006-.89-.599-.89H13.06z"/>
    </svg>
  );
}

export function SolIcon(props) {
  return (
    <svg {...props} viewBox="0 0 24 24" aria-hidden="true">
      <title>solana</title>
      <g fill="none">
        <path fill="url(#g1)" d="M18.413 7.902a.62.62 0 0 1-.411.163H3.58c-.512 0-.77-.585-.416-.928l2.369-2.284a.6.6 0 0 1 .41-.169H20.42c.517 0 .77.59.41.935z"/>
        <path fill="url(#g2)" d="M18.413 19.158a.62.62 0 0 1-.411.158H3.58c-.512 0-.77-.58-.416-.923l2.369-2.29a.6.6 0 0 1 .41-.163H20.42c.517 0 .77.586.41.928z"/>
        <path fill="url(#g3)" d="M18.413 10.473a.62.62 0 0 0-.411-.158H3.58c-.512 0-.77.58-.416.923l2.369 2.29c.111.103.257.16.41.163H20.42c.517 0 .77-.586.41-.928z"/>
        <defs>
          <linearGradient id="g1" x1="3.001" x2="21.459" y1="55.041" y2="54.871" gradientUnits="userSpaceOnUse">
            <stop stopColor="#599db0"/><stop offset="1" stopColor="#47f8c3"/>
          </linearGradient>
          <linearGradient id="g2" x1="3.001" x2="21.341" y1="9.168" y2="9.027" gradientUnits="userSpaceOnUse">
            <stop stopColor="#c44fe2"/><stop offset="1" stopColor="#73b0d0"/>
          </linearGradient>
          <linearGradient id="g3" x1="4.036" x2="20.303" y1="12.003" y2="12.003" gradientUnits="userSpaceOnUse">
            <stop stopColor="#778cbf"/><stop offset="1" stopColor="#5dcdc9"/>
          </linearGradient>
        </defs>
      </g>
    </svg>
  );
}

export function BnbIcon(props) {
  return (
    <svg {...props} viewBox="0 0 32 32" aria-hidden="true">
      <title>bnb</title>
      <g fill="none">
        <circle cx="16" cy="16" r="16" fill="#F3BA2F"/>
        <path fill="#FFF" d="M12.116 14.404L16 10.52l3.886 3.886l2.26-2.26L16 6l-6.144 6.144zM6 16l2.26-2.26L10.52 16l-2.26 2.26zm6.116 1.596L16 21.48l3.886-3.886l2.26 2.259L16 26l-6.144-6.144l-.003-.003zM21.48 16l2.26-2.26L26 16l-2.26 2.26zm-3.188-.002h.002V16L16 18.294l-2.291-2.29l-.004-.004l.004-.003l.401-.402l.195-.195L16 13.706z"/>
      </g>
    </svg>
  );
}

export function AvaxIcon(props) {
  return (
    <svg {...props} viewBox="0 0 32 32" aria-hidden="true">
      <title>avax</title>
      <g fill="none" fillRule="evenodd">
        <circle cx="16" cy="16" r="16" fill="#E84142" fillRule="nonzero"/>
        <path fill="#FFF" d="M11.518 22.75H8.49c-.636 0-.95 0-1.142-.123A.77.77 0 0 1 7 22.025c-.012-.226.145-.503.46-1.055l7.472-13.193c.318-.56.48-.84.682-.944a.77.77 0 0 1 .698 0c.203.104.364.384.682.944l1.536 2.686l.008.014c.343.6.517.906.593 1.226a2.26 2.26 0 0 1 0 1.066c-.076.323-.249.63-.597 1.24l-3.926 6.95l-.01.017c-.346.606-.52.913-.764 1.145a2.3 2.3 0 0 1-.93.54c-.319.089-.675.089-1.387.089zm7.643 0h4.336c.64 0 .962 0 1.154-.126a.77.77 0 0 0 .348-.607c.011-.219-.142-.484-.443-1.005l-.032-.054l-2.172-3.722l-.025-.042c-.305-.517-.46-.778-.657-.879a.76.76 0 0 0-.693 0c-.2.104-.36.377-.678.925l-2.165 3.722l-.007.013c-.317.548-.476.821-.464 1.046a.78.78 0 0 0 .348.606c.188.123.51.123 1.15.123"/>
      </g>
    </svg>
  );
}

export function MaticIcon(props) {
  return (
    <svg {...props} viewBox="0 0 32 32" aria-hidden="true">
      <title>matic</title>
      <g fill="none">
        <circle cx="16" cy="16" r="16" fill="#6F41D8"/>
        <path fill="#FFF" d="M21.092 12.693c-.369-.215-.848-.215-1.254 0l-2.879 1.654l-1.955 1.078l-2.879 1.653c-.369.216-.848.216-1.254 0l-2.288-1.294c-.369-.215-.627-.61-.627-1.042V12.19c0-.431.221-.826.627-1.042l2.25-1.258c.37-.216.85-.216 1.256 0l2.25 1.258c.37.216.628.611.628 1.042v1.654l1.955-1.115v-1.653a1.16 1.16 0 0 0-.627-1.042l-4.17-2.372c-.369-.216-.848-.216-1.254 0l-4.244 2.372A1.16 1.16 0 0 0 6 11.076v4.78c0 .432.221.827.627 1.043l4.244 2.372c.369.215.849.215 1.254 0l2.879-1.618l1.955-1.114l2.879-1.617c.369-.216.848-.216 1.254 0l2.251 1.258c.37.215.627.61.627 1.042v2.552c0 .431-.22.826-.627 1.042l-2.25 1.294c-.37.216-.85.216-1.255 0l-2.251-1.258c-.37-.216-.628-.611-.628-1.042v-1.654l-1.955 1.115v1.653c0 .431.221.827.627 1.042l4.244 2.372c.369.216.848.216 1.254 0l4.244-2.372c.369-.215.627-.61.627-1.042v-4.78a1.16 1.16 0 0 0-.627-1.042l-4.28-2.409z"/>
      </g>
    </svg>
  );
}

export function ArbitrumIcon(props) {
  return (
    <svg {...props} viewBox="0 0 24 24" aria-hidden="true">
      <title>arbitrum-one</title>
      <g fill="none">
        <path fill="#213147" d="M4.515 8.471v7.056c0 .45.245.867.64 1.092l6.205 3.529a1.3 1.3 0 0 0 1.28 0l6.203-3.53c.396-.224.64-.64.64-1.09V8.47c0-.45-.244-.867-.64-1.091L12.64 3.85a1.3 1.3 0 0 0-1.28 0L5.155 7.38a1.25 1.25 0 0 0-.639 1.091"/>
        <path fill="#12aaff" d="m13.353 13.368l-.885 2.39a.3.3 0 0 0 0 .205l1.523 4.112l1.76-1.001l-2.113-5.706a.152.152 0 0 0-.285 0m1.774-4.019a.152.152 0 0 0-.285 0l-.885 2.39a.3.3 0 0 0 0 .205l2.494 6.732l1.761-1.001z"/>
        <path fill="#9dcced" d="M11.998 4.115a.3.3 0 0 1 .126.033l6.715 3.818a.25.25 0 0 1 .126.214v7.635c0 .089-.048.17-.126.214l-6.715 3.819a.25.25 0 0 1-.126.032a.3.3 0 0 1-.125-.032l-6.715-3.815a.25.25 0 0 1-.126-.215V8.182c0-.089.048-.17.126-.215l6.715-3.818a.26.26 0 0 1 .125-.034m0-1.115c-.238 0-.478.06-.692.183L4.593 7A1.36 1.36 0 0 0 3.9 8.182v7.635c0 .487.264.938.693 1.181l6.714 3.819a1.41 1.41 0 0 0 1.386 0l6.714-3.818a1.36 1.36 0 0 0 .693-1.182V8.182A1.36 1.36 0 0 0 19.407 7l-6.716-3.817A1.4 1.4 0 0 0 11.998 3"/>
        <path fill="#213147" d="m7.559 18.685l.617-1.666l1.244 1.018l-1.163 1.046z"/>
        <path fill="#fff" d="M11.433 7.635H9.731a.3.3 0 0 0-.285.197l-3.649 9.852l1.761 1.001l4.018-10.849a.15.15 0 0 0-.143-.2m2.979-.001h-1.703a.3.3 0 0 0-.284.197l-4.167 11.25l1.761 1l4.535-12.246a.15.15 0 0 0-.142-.2"/>
      </g>
    </svg>
  );
}

export const ICONS_BY_KEY = {
  usdt: UsdtIcon,
  usdc: UsdcIcon,
  dai: DaiIcon,
  eth: EthIcon,
  shib: ShibIcon,
  btc: BtcIcon,
  bch: BchIcon,
  ltc: LtcIcon,
  doge: DogeIcon,
  dash: DashIcon,
  xmr: XmrIcon,
  trx: TrxIcon,
  ton: TonIcon,
  sol: SolIcon,
  bnb: BnbIcon,
  avax: AvaxIcon,
  matic: MaticIcon,
  arbitrum: ArbitrumIcon,
};

export function PaymentIcon({ iconKey, className }) {
  const Cmp = ICONS_BY_KEY[iconKey] || UsdtIcon;
  return <Cmp className={className} />;
}